import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithCloseBtn from 'components/root/partials/header/ShortHeaderWithCloseBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { handleChangeDataPagesEditPersonalInfo } from "reduxx/actions/pages/user/editPersonalInfo";
import { EDIT_PERSONAL_INFO } from "apis";
import apiRequest from 'utils/apiRequest';
import { handleChangeProfileData } from 'reduxx/actions/pages/user/login';
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';

const EditPersonalInfo = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { fname, lname, gender } = useSelector(state => state.editPersonalInfo);

    useEffect(() => {
        dispatch(handleChangeDataPagesEditPersonalInfo('fname', profile.fname));
        dispatch(handleChangeDataPagesEditPersonalInfo('lname', profile.lname));
        dispatch(handleChangeDataPagesEditPersonalInfo('gender', profile.gender));
    }, [EditPersonalInfo]);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;

        dispatch(handleChangeDataPagesEditPersonalInfo(name, value));
    };

    const handleSubmitForm = () => {
        if(fname === null || fname.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(lname === null || lname.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام خانوادگی  خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(!gender)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'جنسیت را مشخص کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else {
            apiRequest({
                dispatch,
                endpoint: EDIT_PERSONAL_INFO,
                method: 'post',
                data: { fname, lname, gender },
                token: token,
                successMessage: 'حساب کاربری شما با موفقیت ویرایش شد',
                onSuccess: (res) => {
                    let newProfile = profile;
                    newProfile.fname = fname;
                    newProfile.lname = lname;
                    newProfile.gender = gender;

                    dispatch(handleChangeProfileData(newProfile));
                    navigate('/');
                }
            });
        }
    };      

    return (
        
        <div className={sharedStyles.container}>
        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithCloseBtn />
        		
	            <div className={[formStyles.title, formStyles['mb-24']].join(' ')}>مشخصات خود را وارد فرمایید</div>
				<input name="fname" value={fname} onChange={handleChangeInputs} className={formStyles.input} placeholder="نام" />
				<input name="lname" value={lname} onChange={handleChangeInputs} className={formStyles.input} placeholder="نام خانوادگی" />
                <select name="gender" value={gender} onChange={handleChangeInputs}  className={formStyles.input}>
                    <option>انتخاب کنید</option>
                    <option>مرد</option>
                    <option>زن</option>
                </select>
				<button onClick={handleSubmitForm} className={formStyles.button}>تایید</button>
        	</div>
		</div>

    );
}

export default EditPersonalInfo;